<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section>
    <h4 class="font-weight-bolder">Additional Participants</h4>
    <section v-if="!loading" class="mt-1">
      <div v-for="participant in additionalVisitors" :key="participant._id">

        <div class="d-flex justify-content-between flex-column mb-1">
          <div class="d-flex justify-content-start">
                <span class="b-avatar badge-light-danger rounded" style="width: 70px; height: 70px;">
                  <span class="b-avatar-img">
                    <img :src="participant.assets.profile_picture_url" alt="avatar">
                  </span><!---->
                </span>
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0"> {{ participant.firstname }} {{ participant.lastname }} </h4>
                Status: {{ participant.verification_status }}

              </div>

            </div>
          </div>
        </div>

      </div>
      <p v-if="additionalVisitors.length === 0">No participants</p>
    </section>
    <section v-else>
      <b-spinner variant="primary" label="Loading"></b-spinner>
    </section>

  </section>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';

  export default {
    components: {},
    props: {},
    data() {
      return {
        loading: true,
        additionalVisitors: [],
      };
    },
    computed: {
      ...mapState({
        call: state => state.myCalls.call,
      }),
    },
    mounted() {
      this.getAdditionalVisitors();
    },
    methods: {
      getAdditionalVisitors() {
        AdditionalVisitorsService.getVisitors(this.call._id).then(res => {
          if (res.data && res.data.length > 0) {
            this.additionalVisitors = res.data;
          }
        }).catch(() => {
          this.$toast.error('Error getting users additional participants. Please check your connection and refresh the page', {
            toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
